$(document).ready(function()
{
    // change the contents of a standard modal on clock, for product zooms
    if ( $('#defaultZoomModal').length )
    {
        $('.zoom-in-image, .zoom-in-background').click(function(e)
        {
            e.preventDefault();

            var useImg = $(this).find("img").data('large-size');
            var useAlt = $(this).find("img").attr('alt');
            var useCaption = $(this).find("figcaption").html();

            var hasCaption = (useCaption !== 'undefined') ? true : false;

            if (useImg)
            {
                $('#defaultZoomModalImage').attr('src', useImg);
                $('#defaultZoomModalImage').attr('alt', useAlt);     
                $('#defaultZoomModalTitle').html(useAlt);

                if (hasCaption)
                {
                    $('#defaultZoomModalFig').addClass("active");
                    $('#defaultZoomModalFig').html(useCaption);
                }
                else
                {
                    $('#defaultZoomModalFig').removeClass("active");
                    $('#defaultZoomModalFig').html("");
                }

                setTimeout(function () 
                {
                    $('#defaultZoomModal').foundation('open');
                }, 100);
            }

        });

        $('#customCloseModal').click(function()
        {
            $('#defaultZoomModal').foundation('close');
        });

    };

});
